import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import vector from '../../assets/Vector.png';
import './filter.css';
import Dropdown from '../life-dropdown';
import CustomInputBox from '../selectTextInput';
import formatSumAssured from '../../utilities/calculateSum';
import { updateFirstPageData, healthEnquiryAPI } from '../../Redux/HealthRedux';

export const FilterBar = ({ CallQuoteAPIs }) => {
  const combinedRedux = useSelector((state) => state.health.combinedRedux);
  const dispatch = useDispatch();

  const [tenure, setTenure] = useState(combinedRedux.tenure || '1');
  const [sumAssured, setSumAssured] = useState(combinedRedux.sumAssured || '1500000'); // Set sum assured
  // const [company, setCompany] = useState(''); // Set company

  // Tenure options
  const tenureOptions = [
    'Select',
    '1',
    '2',
    '3',
    '4',
    '5',
  ];

  // Sum Assured options
  const sumAssuredOptions = [
    'Select',
    '1 Lac',
    '5 Lac',
    '10 Lac',
    '20 Lac',
    '50 Lac',
    '1 Cr',
    '5 Cr',
    '10 Cr',
  ];

  const [healthFilter, setHealthFilter] = useState({
    tenure: '',
    sumAssured: '',
  });

  useEffect(() => {
    if (healthFilter.sumAssured != '') {
      dispatch(
        updateFirstPageData({
          sumAssured: healthFilter.sumAssured,
          enquiryId: combinedRedux.enquiryId,
        })
      )
        .then(() => {
          dispatch(healthEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
          CallQuoteAPIs();
        })
        .catch((error) => {
          console.error('Error updating sumAssured:', error);
        });
    }
  }, [healthFilter.sumAssured]);

  useEffect(() => {
    if (healthFilter.tenure != '') {
      dispatch(
        updateFirstPageData({
          tenure: healthFilter.tenure,
          enquiryId: combinedRedux.enquiryId,
        })
      )
        .then(() => {
          dispatch(healthEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
          CallQuoteAPIs();
        })
        .catch((error) => {
          console.error('Error updating tenure:', error);
        });
    }
  }, [healthFilter.tenure]);

  // Handle changes for the filters
  const handleTenureChange = (e) => {
    setHealthFilter({ ...healthFilter, tenure: e.target.value });
  };

  const handleSumAssured = (value) => {
    if (value > 10000000) {
      setSumAssured(10000000);
      setHealthFilter({ ...healthFilter, sumAssured: 10000000 });
    } else if (value != '') {
      setSumAssured(value);
      setHealthFilter({ ...healthFilter, sumAssured: value });
    }
  };

  // const handleCompanyChange = (e) => {
  //   setCompany(e.target.value);
  // };

  return (
    <div className="filter">
      <label htmlFor="dropdown" className="labIcon">
        Filters
        <span>
          <img style={{ paddingLeft: '2px' }} src={vector} alt="ram" />
        </span>
      </label>
      <div className="dataDown">
        {/* Tenure Filter */}
        <Dropdown
          options={tenureOptions}
          label={'Tenure'}
          className="custom-dropdown"
          onChange={handleTenureChange}
          value={combinedRedux.tenure}
        />

        {/* Sum Assured Filter */}
        <CustomInputBox
          label={`Sum Assured (${formatSumAssured(sumAssured)})`}
          placeholder={'Enter Sum Assured'}
          sum={true}
          value={combinedRedux.sumAssured}
          onChange={handleSumAssured}
        />

        {/* Company Filter */}
        {/* <Dropdown
          options={['Select', 'ICICI', 'HDFC', 'TATA', 'Bajaj', 'SBI']}
          label={'Company'}
          className="custom-dropdown"
          onChange={handleCompanyChange}
          value={company}
        /> */}
      </div>
    </div>
  );
};
